<template>
  <div id="app">
    <top-page />
  </div>
</template>

<script>
import TopPage from './components/pages/TopPage';

export default {
  name: 'app',
  components: {
    TopPage,
  },
};
</script>

<style lang="scss">
@import './constants/style';

:root {
  --color-blue: #3399db;
  --color-red: #e72c3d;
  --color-yellow: #f7cb18;
  --color-green: #4ed17b;
  --color-gray: #99989b;
  --color-black: #343438;
}

/* reset */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  min-height: 100vh;
  scroll-behavior: smooth;
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

img {
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
}

svg {
  vertical-align: middle;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* style */
html,
body {
  height: 100%;
}

body {
  color: var(--color-black);
  min-width: 1024px;
  font-family: 'Lato', 'Noto Sans JP', '游ゴシック Medium', '游ゴシック体', 'Yu Gothic Medium', YuGothic,
    'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
}

#app {
  height: 100%;
}

@media #{$mq-pc} {
  [data-only-sp] {
    display: none !important;
  }
}

@media #{$mq-sp} {
  body {
    min-width: 320px;
  }

  [data-only-pc] {
    display: none !important;
  }
}
</style>
